"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var NotFoundContent = function (_a) {
    var _b = _a.onlyBtn, onlyBtn = _b === void 0 ? false : _b, _c = _a.children, children = _c === void 0 ? null : _c;
    var t = (0, next_intl_1.useTranslations)('translation');
    var router = (0, navigation_1.useRouter)();
    var navigateHome = (0, react_1.useCallback)(function () {
        router.push('/');
    }, [router]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.notFoundWrapper },
        !onlyBtn ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(image_1.default, { width: 200, height: 100, src: "/img/logo.svg", alt: "luckyLabs" }),
            react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                    __html: t.raw("pageNotFound"),
                } }))) : (children),
        react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", color: "gradient", text: "upper", height: "44px", maxWidth: "220px", onClick: navigateHome }, t('toHomePage'))));
};
exports.default = NotFoundContent;
